import { render, staticRenderFns } from "./addListBtn.vue?vue&type=template&id=5de10e8e&scoped=true&lang=pug&"
import script from "./addListBtn.vue?vue&type=script&lang=js&"
export * from "./addListBtn.vue?vue&type=script&lang=js&"
import style0 from "./addListBtn.vue?vue&type=style&index=0&id=5de10e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de10e8e",
  null
  
)

export default component.exports